import * as Sentry from '@sentry/react';
import { useEffect } from 'react';
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router-dom';

if (process.env.REACT_APP_ENV !== 'development') {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    environment: process.env.REACT_APP_ENV,
    beforeSend(event, hint) {
      // Check if it is an exception, and if so, show the report dialog
      if (event.exception && event.event_id) {
        Sentry.showReportDialog({
          title: 'Схоже, у нас проблеми.',
          subtitle: 'Наша команда була повідомлена.',
          subtitle2:
            'Якщо ви хочете допомогти, розкажіть нам про те, що сталося, нижче.',
          labelName: "Повне ім'я",
          labelEmail: 'Email',
          labelComments: 'Що трапилося?',
          labelClose: 'Закрити',
          labelSubmit: 'Надіслати',
          errorGeneric:
            'Під час відправлення звіту сталася невідома помилка. Будь ласка, спробуйте ще раз.',
          errorFormEntry:
            'Деякі поля були введені невірно. Будь ласка, виправте помилки та спробуйте ще раз.',
          successMessage: 'Ваш відгук надіслано. Дякуємо!',
          eventId: event.event_id,
          onClose() {
            location.reload();
          },
        });
      }
      return event;
    },
    integrations: [
      Sentry.reactRouterV6BrowserTracingIntegration({
        useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
      Sentry.feedbackIntegration({
        colorScheme: 'light',
        showBranding: false,
        isNameRequired: true,
        isEmailRequired: true,
        triggerLabel: '',
        formTitle: 'Залиште відгук',
        nameLabel: "Повне ім'я",
        namePlaceholder: "Повне ім'я",
        messageLabel: 'Опис',
        messagePlaceholder: 'У чому помилка? Якої поведінки ви очікували?',
        isRequiredLabel: "(Обов'язкове поле)",
        addScreenshotButtonLabel: 'Додати скриншот',
        removeScreenshotButtonLabel: 'Видалити скриншот',
        submitButtonLabel: 'Надіслати звіт про помилку',
        cancelButtonLabel: 'Відмінити',
        successMessageText: 'Дякуємо за вашу допомогу!',
      }),
    ],
    // Tracing
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: [process.env.REACT_APP_SENTRY_DOMAIN as string],
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });
}
